export default __webpack_public_path__ + "static/media/admin.728eb2fd.svg";